/* eslint-disable @typescript-eslint/no-explicit-any */
import { useTeamListQuery } from '@gen2/api/team/hooks';
import { PermissionsKeys } from '@gen2/types/permissions';
import { SearchCondition } from '@gen2/types/search-condition';
import { TTeam } from '@gen2/types/team';
import { useEffect, useMemo, useState } from 'react';
import { useDebounceValue } from 'usehooks-ts';
import { useSendInviteStore } from './store';

export const useTeam = () => {
  const initialSearchCondition: SearchCondition = useMemo(
    () => ({
      'sort[column]': 'name',
      'sort[order]': 'asc',
      'filter[permission]': [PermissionsKeys.SHOW_INVITE_TEAM],
      per_page: 10,
      page: 1,
    }),
    [],
  );
  const [selectedTeam, setSelectedTeam] = useState<TTeam | null>(null);

  const { invite } = useSendInviteStore();
  const [searchTeam, setSearchTeam] = useState('');
  const [debouncedValue] = useDebounceValue(searchTeam, 300);
  const [searchCondition, setSearchCondition] = useState(
    initialSearchCondition,
  );

  const { data: teams, isLoading: isTeamsLoading } =
    useTeamListQuery(searchCondition);

  const optionsTeam = useMemo(() => {
    if (!teams?.data) return [];

    return teams.data as TTeam[];
  }, [teams]);

  // update default selected point of contact when invite is stored
  useEffect(() => {
    if (invite?.team) {
      setSelectedTeam(invite.team);
    }
  }, [invite]);

  useEffect(() => {
    if (debouncedValue) {
      setSearchCondition((prev) => ({
        ...prev,
        'filter[search]': debouncedValue,
      }));
    } else {
      setSearchCondition(initialSearchCondition);
    }
  }, [debouncedValue, initialSearchCondition]);

  return {
    optionsTeam,
    isTeamsLoading,
    selectedTeam,
    setSelectedTeam,
    setSearchTeam,
  };
};
